import AboutMetricsGdaScore from './AboutMetricsGdaScore.tsx';
import AboutMetricsPleiotropy from './AboutMetricsPleiotropy.tsx';
import AboutMetricsSpecificity from './AboutMetricsSpecificity.tsx';
import AboutMetricsVdaScore from './AboutMetricsVdaScore.tsx';
import AboutMetricsEvidenceIndex from './AboutMetricsEvidenceIndex.tsx';
import AboutMyScore from './AboutMyScore.tsx';

function AboutMetrics() {
  return (
    <div>
      {' '}
      <h2>DISGENET Metrics</h2>
      <p>
        We have developed two scores to rank the gene-disease, and the variant-disease associations according
        to their level of evidence. These scores range from 0 to 1, and take into account the number and type
        of sources (level of curation, model organisms), and the number of publications supporting the
        association.
      </p>
      <div>
        <div className="mb-2 divider" />
        <AboutMetricsGdaScore />
        <div className="mb-2 divider" />
        <AboutMetricsVdaScore />
        <div className="mb-2 divider" />
        <AboutMyScore />
        <div className="mb-2 divider" />
        <AboutMetricsSpecificity />
        <div className="mb-2 divider" />
        <AboutMetricsPleiotropy />
        <div className="mb-2 divider" />
        <AboutMetricsEvidenceIndex />
      </div>
    </div>
  );
}

export default AboutMetrics;
